/* global angular */

export default function EditSOCCommentDialogController(
  $rootScope,
  $scope,
  $q,
  loaderService,
  ssDialogService,
  vmDataService,
) {
  const vm = this;

  vm.newProductSocComment = getSanitizedContactModel(vm.productSocComment);
  vm.handleEditSOCCommentFormSubmit = _handleEditSOCCommentFormSubmit;
  vm.handleCloseDialog = _handleCloseDialog;

  function _handleEditSOCCommentFormSubmit() {
    if ($scope.editSOCCommentForm.$valid) {
      const isNew = vm.newProductSocComment.productSocCommentId <= 0;

      if (!isNew && angular.equals(vm.productSocComment, vm.newProductSocComment)) {
        // No need to save
        return _closeDialog(); // or return Promise.resolve();
      }

      return _saveSOCComment(isNew).then(() => {
       _closeDialog();
      });
    }
  }

  function _saveSOCComment(isNew) {
    loaderService.showViewLoader = true;
    return vmDataService.saveSOCComment(vm.newProductSocComment).then((response) => {
      loaderService.showViewLoader = false;
      const savedSocComment = response.data;

      angular.extend(vm.newProductSocComment, savedSocComment);
      angular.extend(vm.productSocComment, vm.newProductSocComment);
      if (isNew) {
        vm.addCallback(vm.productSocComment);
      } else {
        vm.editCallback(vm.productSocComment);
      }
      return true;
    });
  }

  function _handleCloseDialog() {
    _closeDialog();
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.vendorManagement.editSOCCommentDialog);
  }

  function getSanitizedContactModel(apiModel) {
    return {
      productSocCommentId: apiModel.productSocCommentId || apiModel.ProductSOCCommentID,
      productId: apiModel.productId || apiModel.ProductID,
      text: apiModel.text || apiModel.Text,
      // createdDate: apiModel.createdDate,
      // createUserId: apiModel.createUserId,
      // createdUser: apiModel.createdUser,
    };
  }
}

EditSOCCommentDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'loaderService',
  'ssDialogService',
  'vmDataService',
];
